import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to (0,0) on every route change.
 * Place inside <BrowserRouter> but outside <Routes>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
